<template>
    <base-modal
        :zoom-in="true"
        :show-circle="aiActiveState === aiStates.default"
        :show-bg="showBg"
        :show-close="false"
        @close="close"
        :class="activeStateClass"
        class="cz2__ai-modal"
    >
        <transition
            :name="transitionName"
            mode="out-in"
        >
            <get-started-state v-if="aiActiveState === aiStates.default" />

            <selfie-state v-else-if="aiActiveState === aiStates.selfie" />

            <upload-state v-else-if="aiActiveState === aiStates.upload" />
        </transition>

        <beta-badge v-if="showBetaBadge">
            {{ $t('AI_BETA') }}
        </beta-badge>
    </base-modal>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__ai-modal {
            .cz2__base-modal-content-wrapper {
                width: 90%;
                height: 90%;

                overflow: hidden;
            }

            .cz2__modal-popup__header,
            .cz2__modal-popup__copy {
                text-transform: none;
            }

            .cz2__modal-popup__super-header {
                font-size: 16px;
            }

            .cz2__modal-popup__copy {
                font-size: 14px;
            }

            .cz2__ai-modal__buttons {
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 12px;

                .cz2__btn {
                    width: 100%;

                    &:focus::before {
                        border: none;
                    }
                }
            }

            .cz2__modal-popup__header {
                margin-bottom: 0;
                font-size: 36px;
            }

            .cz2__btn {
                height: 40px;
                width: 230px;
                font-size: 16px;

                &:hover {
                    font-size: 18px;
                }
            }

            .cz2__ai-modal-beta {
                position: absolute;
                top: 16px;
                left: 16px;
            }

            @include respond-above(md) {
                .cz2__ai-modal__buttons {
                    width: 386px;
                }

                .cz2__modal-popup__copy {
                    font-size: 16px;
                }
            }

            @include respond-above(lg) {
                .cz2__base-modal-content-wrapper {
                    max-width: 1152px;
                    max-height: 672px;
                }

                &:not(.cz2__ai-get-started) {
                    .cz2__base-modal-content {
                        padding: 24px 64px;
                    }
                }
            }

            @include respond-below(sm) {
                &:not(.cz2__ai-get-started) {
                    .cz2__base-modal-content-wrapper {
                        width: 100%;
                        height: 100%;
                        border-radius: 0;
                    }
                }
            }

            .cz2__base-modal-content-wrapper {
                @media screen and (min-height: 830px) and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
                    max-width: 800px !important;
                }

                @media screen and (min-height: 1000px) and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
                    max-height: 975px;
                }
            }
        }
    }
</style>

<script>
    import BaseModal from '../ui/BaseModal.vue';
    import GetStartedState from './GetStartedState.vue';
    import SelfieState from './SelfieState.vue';
    import UploadState from './UploadState.vue';
    import BetaBadge from './BetaBadge.vue';

    export default {
        components: {
            BaseModal,
            GetStartedState,
            SelfieState,
            UploadState,
            BetaBadge,
        },

        computed: {
            aiActiveState() {
                return this.$store.state.aiActiveState;
            },

            aiStates() {
                return this.$store.state.aiStates;
            },

            activeStateClass() {
                let activeClass = 'cz2__ai-get-started';

                if (this.aiActiveState === this.aiStates.selfie) {
                    activeClass = 'cz2__ai-selfie';
                } else if (this.aiActiveState === this.aiStates.upload) {
                    activeClass = 'cz2__ai-upload';
                }

                return activeClass;
            },

            transitionName() {
                return this.isMobile ? '' : 'cz2__fade';
            },

            showBg() {
                return (this.aiActiveState === this.aiStates.default && this.isMobile) || !this.isMobile;
            },

            aiUploadActiveState() {
                return this.$store.state.aiUploadActiveState;
            },

            aiUploadStates() {
                return this.$store.state.aiUploadStates;
            },

            aiSelfieActiveState() {
                return this.$store.state.aiSelfieActiveState;
            },

            aiSelfieStates() {
                return this.$store.state.aiSelfieStates;
            },

            showBetaBadge() {
                const notDefaultState = this.aiActiveState !== this.aiStates.default;
                const notErrorState = this.aiUploadActiveState !== this.aiUploadStates.error
                    && this.aiSelfieActiveState !== this.aiSelfieStates.error;

                return notDefaultState && notErrorState;
            },

            isMobile() {
                return this.$store.state.customizer.isMobile;
            },
        },

        watch: {
            // Clear any error states when active state changes.
            aiActiveState() {
                this.$store.dispatch('resetAiStates');
            },
        },

        beforeDestroy() {
            this.close();
        },

        methods: {
            close() {
                this.$store.dispatch('showAiModal', false);
                this.$store.dispatch('resetAiStates');
                this.$store.dispatch('setAiActiveState', this.aiStates.default);
            },
        },
    };
</script>
